module.exports = __webpack_public_path__ + "static/media/themeOff.0981f5bf.svg";